import { useEffect } from "react";

// Lightweight per-page metadata updater (no extra dep).
// Replaces title + meta description + og:title + og:description.
export default function useSEO({ title, description }) {
    useEffect(() => {
        if (title) document.title = title;
        const set = (selector, attr, value) => {
            if (!value) return;
            const el = document.head.querySelector(selector);
            if (el) el.setAttribute(attr, value);
        };
        set('meta[name="description"]', "content", description);
        set('meta[property="og:title"]', "content", title);
        set('meta[property="og:description"]', "content", description);
    }, [title, description]);
}
